module.exports = __webpack_public_path__ + "img/help.213273f7.svg";